import { ButtonProps } from "primereact/button";
import { RefObject, useRef, useState } from "react";
import { Tooltip } from "primereact/tooltip";

interface CustomButtonProps extends ButtonProps {
  tooltip?: string;
  tooltipOptions?: {
    position?: "top" | "bottom" | "left" | "right" | "mouse" | undefined;
    className?: string;
    showDelay?: number;
    hideDelay?: number;
    event?: "hover" | "focus" | "both" | undefined;
  };
}

const CustomButton: React.FC<CustomButtonProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const {
    onClick,
    icon,
    tooltip,
    tooltipOptions, // tách riêng ở đây
    className,
    style,
    disabled,
    children,
    ...restProps // không còn tooltipOptions nữa
  } = props;

  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setLoading(true);
    try {
      if (onClick) await onClick(event);
    } catch (error) {
      console.error("Error in button click handler:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {tooltip && (
        <Tooltip
          target={buttonRef as RefObject<HTMLElement>}
          content={tooltip}
          {...tooltipOptions} // truyền vào đây
        />
      )}

      <button
        {...restProps}
        onClick={handleClick}
        ref={buttonRef}
        className={`${className || ""}`}
        style={{ ...style }}
        disabled={disabled || loading}
      >
        {loading ? (
          <span className="pi pi-spin pi-spinner-dotted" />
        ) : (
          <div className="flex items-center justify-center w-full h-full">
            {icon && <span className={`pi ${icon}`} />}
            {children}
          </div>
        )}
      </button>
    </>
  );
};

export default CustomButton;
